import { lazy, Suspense } from 'react';
import { PageTitle } from '../../components/PageTitle';
import { CvProvider } from './context/CvContext';

const CvGeneratorContent = lazy(() =>
  import('./CvGeneratorContent').then((m) => ({ default: m.CvGeneratorContent }))
);

export const CvGenerator = () => {
  return (
    <div>
      <PageTitle title="Lebenslauf-Generator" />
      <div style={{ position: 'relative' }}>
        <Suspense fallback={
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
            fontSize: '16px',
            color: '#666',
          }}>
            Lebenslauf-Generator wird geladen...
          </div>
        }>
          <CvProvider>
            <CvGeneratorContent />
          </CvProvider>
        </Suspense>
      </div>
    </div>
  );
};
